import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {URL} from '../../Config/appConfig';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {Auth, UpdateUser} from '../../Config/dataModel';
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import {assertAllTrue, clearErrors} from '../../Util/errorUtil';
import util from '../../Util/util';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import CloseButton from '../Custom/CloseButton';
import Checkbox from '@material-ui/core/Checkbox';
import '../../style/settings.css';
import '../../style/success.css';

const btnSpinner = require('../../resource/img/button-loading.gif');

interface SettingsProps {
    updateUser: (data: UpdateUser) => void,
    updateUserState: () => boolean,
    auth: () => Auth,
    subscribe: () => boolean
}

interface SettingsState {
    btnLoading: boolean,
    firstName: string,
    lastName: string,
    oldPassword: string,
    password: string,
    confirmPassword: string,
    subscribe: boolean,
    submitted: boolean
}

class Settings extends React.Component <RouteComponentProps & SettingsProps, SettingsState> {
    public updateUser: boolean = false;

    public constructor(props: SettingsProps) {
        super(props);
        this.state = {
            btnLoading: false,
            firstName: this.props.auth().user.firstName,
            lastName: this.props.auth().user.lastName,
            oldPassword: '',
            password: '',
            confirmPassword: '',
            subscribe: this.props.subscribe(),
            submitted: false
        };
        this.changePassword = this.changePassword.bind(this);
        this.changeName = this.changeName.bind(this);
        this.changeSubscription = this.changeSubscription.bind(this);
        this.clickCancel = this.clickCancel.bind(this);
        this.clickSubmit = this.clickSubmit.bind(this);
        this.onError = this.onError.bind(this);
    }

    public componentWillReceiveProps(nextProps: SettingsProps) {
        if (this.updateUser && nextProps.updateUserState()) {
            this.updateUser = false;
            this.setState({btnLoading: false, password: '', oldPassword: '', confirmPassword: '', submitted: true});
        }
    }

    public changePassword(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        const target = event.target;
        this.setState({
            ...this.state,
            [target.name]: target.value
        });
    }

    public changeName(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        const target = event.target;
        const value = target.value;
        if (value.length <= 10 && value.match(/^([a-z0-9-.\s]|)+$/i)) {
            this.setState({
                ...this.state,
                [target.name]: value
            });
        }
    }

    public changeSubscription(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        this.setState({subscribe: event.target.checked});
    }

    public clickSubmit(event: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        clearErrors();
        this.setState({submitted : false});
        const data = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            receiveEmailNotification: this.state.subscribe
        };
        // If user enters either one field, we treat it as if he/she intends to change password
        if (this.state.oldPassword || this.state.password || this.state.confirmPassword) {
            const valid = assertAllTrue([
                {code: 152, hasResult: this.state.oldPassword.length > 0},
                {code: 161, hasResult: util.isPasswordStrong(this.state.password)},
                {code: 164, hasResult: this.state.password === this.state.confirmPassword}
            ]);
            if (valid) {
                data['password'] = this.state.password;
                data['oldPassword'] = this.state.oldPassword;
            }
            else return;
        }
        this.setState({
            btnLoading: true
        });
        this.updateUser = true;
        this.props.updateUser(data);
    }

    public clickCancel() {
        this.props.history.push(URL.COVER_NOTE);
    }

    public onError() {
        this.setState({
            btnLoading: false
        });
    }

    public render() {
        let closeButtonExtraProps = {};
        if (this.props.location.state && this.props.location.state.fromDashboard) {
            closeButtonExtraProps = {...closeButtonExtraProps, ...{goBack: true}};
        }
        return (
            <div className="cmHorCenter cmFormContainer commonForm">
                <div className="cmFormTitleHeader">
                    <div className="cmFormTitle">Account Settings</div>
                    <CloseButton {...closeButtonExtraProps}/>
                </div>
                <form className="settingsFormContainer" onSubmit={this.clickSubmit}>
                    <div className="cmText settingsTitle">Change Display Name</div>
                    <div className="cmInput">
                        <Grid item xs={12}>
                            <div className="cmInput2Cols">
                                <Grid item xs={6} className="">
                                    <div className="cmFormInput">
                                        <TextField
                                            label="First Name"
                                            name="firstName"
                                            value={this.state.firstName}
                                            onChange={this.changeName}
                                            InputProps={{disableUnderline: true}}/>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div className="cmFormInput">
                                        <TextField
                                            label="Last Name"
                                            name="lastName"
                                            value={this.state.lastName}
                                            onChange={this.changeName}
                                            InputProps={{disableUnderline: true}}/>
                                    </div>
                                </Grid>
                            </div>
                        </Grid>
                    </div>
                    <div className="cmText settingsTitle passwordTitle">Change Password</div>
                    <div className="cmInput cmFormInput">
                        <Grid item xs={12}>
                            <TextField
                                label="Old Password" type="password"
                                value={this.state.oldPassword} name="oldPassword" onChange={this.changePassword}
                                InputProps={{disableUnderline: true}}/>
                        </Grid>
                    </div>
                    <div className="cmInput cmFormInput">
                        <Grid item xs={12}>
                            <TextField
                                label="New Password" type="password"
                                value={this.state.password} name="password" onChange={this.changePassword}
                                InputProps={{disableUnderline: true}}/>
                        </Grid>
                    </div>
                    <div className="cmInput cmFormInput">
                        <Grid item xs={12}>
                            <TextField
                                label="Confirm New Password" type="password"
                                value={this.state.confirmPassword} name="confirmPassword"
                                onChange={this.changePassword}
                                InputProps={{disableUnderline: true}}/>
                        </Grid>
                    </div>
                    <div className="cmText settingsTitle passwordTitle">Email Settings</div>
                    <div className="cmInput cmFormInput">
                        <Grid className="emailSettings" item xs={12}>
                            <Checkbox
                                className="cmCheckbox"
                                checked={this.state.subscribe}
                                onChange={this.changeSubscription}
                                color="default"/>
                            <span className="cmText">Send me emails about my daily activity report</span>
                        </Grid>
                    </div>
                    <ErrorHandler onError={this.onError}/>
                    {this.state.submitted &&
                    <div className="successMsgContainer show">
                        <span className="successMsg">User updated successfully!</span>
                    </div>}
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button type="button" className="cmBtn cmGreyBtn cmBoldText" onClick={this.clickCancel}
                                    disabled={this.state.btnLoading}>Cancel
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmBlueBtn cmBoldText" onClick={this.clickSubmit}
                                    disabled={this.state.btnLoading}>
                                <span className="cmBtnText">Submit</span>
                                {this.state.btnLoading && <img className="cmBtnSpinner" src={btnSpinner}/>}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default withRouter(connect(authState, authDispatch)(Settings));



// WEBPACK FOOTER //
// ./src/Components/Settings/Settings.tsx